<template>
  <div id="nav">
    <b-navbar toggleable="sm" variant="white" id="main-navbar">
      <!-- Brand -->
      <p  href="/" id="brand-title">Pokeland - Carnet d'adresses</p>

      <!-- Navbar Toggle Button for Hamburger Menu on Small Screens -->
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <!-- Collapsible Navbar Content -->
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <!-- Nav Items -->
          <b-nav-item :class="isSelected('/')" href="/" class="text-primary nav-link-responsive">Commandes</b-nav-item>
          <b-nav-item :class="isSelected('/list/users')" href="/list/users" class="nav-link-responsive">Clients</b-nav-item>
          <b-nav-item :class="isSelected('/list/evenement')" href="/list/evenement" class="nav-link-responsive">Evenement</b-nav-item>

        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: "home-navbar",
  methods: {
    isSelected(url) {
      return url == window.location.pathname ? "selected" : "not-selected";
    }
  }
};
</script>

<style lang="scss">
@import "src/assets/styles/custom_variables";

img {
  border-radius: 50%;
  height: 55px;
  width: 55px;
}

#nav .container {
  padding-top: 5px;
  padding-bottom: 5px;
  max-width: 100%;
}

.navbar-light .navbar-nav .nav-link {
  font-size: 20px;
  font-weight: bold;
  margin: 0px 20px;
  letter-spacing: 0.4px;
  color: $primary;
}

#main-navbar {
  border-bottom: solid 1px $light;
}

.selected {
  border-radius: 10px;
  background-color: $light;
}

.not-selected {
  background-color: white;
}

#brand-title {
  margin-bottom: 0;
  font-size: 1.5rem;
  font-family: Barlow-Semi;
  color: $dark;
}

.nav-link-responsive {
  padding: 10px 15px;
}

#nav .b-navbar-nav {
  display: flex;
}

@media (max-width: 768px) {
  #nav .b-navbar-nav {
    flex-direction: column;
    align-items: flex-start;
  }

  .nav-link-responsive {
    width: 100%;
  }
}

@media (min-width: 769px) {
  #nav .b-navbar-nav {
    flex-direction: row;
  }

  .nav-link-responsive {
    text-align: center;
    width: auto;
  }
}
</style>
